var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: ".005%",
    y1: "49.999%",
    x2: "100%",
    y2: "49.999%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8C4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.991%",
    y1: "49.999%",
    x2: "54.01%",
    y2: "50%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49F4FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#49F4FF",
    d: "M302.685 3.001v520.676h-4.503V3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298 0v529a16.47 16.47 0 01-9.91-3.482L154.12 412.219a17.216 17.216 0 01-5.491-13.034V118.601a16.487 16.487 0 015.56-12.835L288.555 3.592A14.832 14.832 0 01298 0z",
    fill: "url(#a)",
    transform: "matrix(-1 0 0 1 597.622 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.378 0v527.5a16.5 16.5 0 01-9.91-3.473L5.498 411.05a17.144 17.144 0 01-5.491-12.997V118.265a16.419 16.419 0 015.56-12.799L139.933 3.582A14.856 14.856 0 01149.378 0z",
    fill: "url(#b)",
    transform: "translate(151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.517 146.063a19.689 19.689 0 0123.956 0l.202.159 78.559 63.43a.664.664 0 00.56-.085l.57-.352 80.376-46.037.172-.112c11.545-7.405 28.46-.66 29.071 13.44l.017.791-.005 250.793c-.168 5.094-2.538 9.857-6.265 12.847l-182.22 155.45-.87.475c-7.968 4.359-18.207 4.189-25.139-.586l-.41-.282-182.32-155.603c-3.505-3.154-5.598-7.65-5.771-12.744v-250.35c0-14.367 16.737-21.551 28.464-14.637l.796.498 80.416 46.057.568.352c.143.095.31.13.425.142l.108.004zM391.74 380.069l-78.897 65.813-.32.256a19.885 19.885 0 01-2.758 1.769l-.01 126.21L475.99 432.311l-84.25-52.242zm-182.461-.013l-84.234 52.167 165.467 141.22.008-125.987a19.91 19.91 0 01-1.625-1.072l-.329-.246-.319-.255-78.968-65.827zm91.105-218.6h-.063l-78.728 63.643c-.111.084-.223.168-.336.25l-1.569 1.268-.004 136.883 80.498 67.108.164.089a.626.626 0 00.396 0l.149-.085 80.467-67.108V226.586l-1.363-1.1-.765-.557-78.374-63.32-.16-.088a.924.924 0 00-.312-.066zm182.37 18.362l-80.74 46.242-.393.25c-.335.203-.674.394-1.018.574l-.002 135.843 82.152 50.94V179.818zm-364.512-.023l-.008 233.818 82.211-50.915.002-135.808c-.382-.2-.76-.414-1.131-.642l-.346-.217.07.04-.41-.262.339.221-80.727-46.235z",
    fill: "#6800FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTn);
export default __webpack_public_path__ + "static/media/TN.41f7e89eeb5e0b749ddee1b11670f297.svg";
export { ForwardRef as ReactComponent };